import type {Result, UseCase} from 'framework';
import type {DashboardError} from '../../domain/errors';
import type {MealId} from '../../domain/meal-id.value-object';
import type {DashboardRepository} from '../ports/dashboard.repository';

export interface DeleteMealInput {
  readonly mealId: MealId;
}

export class DeleteMeal implements UseCase<[DeleteMealInput], void> {
  constructor(private readonly dashboardRepository: DashboardRepository) {}

  execute(input: DeleteMealInput): Promise<Result<void, DashboardError>> {
    return this.dashboardRepository.deleteMeal({mealId: input.mealId});
  }
}
